import {mergeToHierarchy} from '#core/utils/config-utils.js';

import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';

import SCHEMA from './skeleton.schema.yaml';

class SkeletonFeature extends AbstractFeature {
    get name() {
        return 'Skeleton';
    }

    get enabled() {
        // Feature itself is always enabled
        return true;
    }

    get configSchema() {
        return SCHEMA;
    }

    beforeMojitoConfigBuild(mojitoConfig) {
        const {enabled} = this.config;

        mergeToHierarchy(mojitoConfig, 'services.configurations', {
            LoaderSuspense: {
                disableLoader: !enabled,
                showLoaderDelay: 750,
            },
        });

        return super.beforeMojitoConfigBuild(mojitoConfig);
    }
}

export const Skeleton = new SkeletonFeature(allFeatures);
